export const PIE_CHART_CONFIG = {
  innerRadius: 65,
  outerRadius: 95,
  paddingAngle: 0,
  cx: '50%',
  cy: '50%',
  dataKey: 'value',
} as const
